import { type CSSProperties } from 'typestyle/lib/types';
import { type SxProps } from '@mui/material';
import StyleConstants from '../../core/styles.constants';

export const headerMargin: CSSProperties = {
  marginBottom: 16,
};

export const bottomMargin: CSSProperties = {
  marginBottom: 24,
  paddingBottom: 24,
};

export const tooltipIcon: CSSProperties = {
  cursor: 'pointer',
  color: StyleConstants.GREY_COLOR,
  height: 18,
  width: 18,
};

export const tooltipIconSX: SxProps = {
  cursor: 'pointer',
  color: StyleConstants.GREY_COLOR,
  height: 18,
  width: 18,
};

export const label: CSSProperties = {
  marginTop: 10,
  fontSize: StyleConstants.SECONDARY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  color: StyleConstants.GREY_COLOR,
};

export const labelError: CSSProperties = {
  fontSize: StyleConstants.TERTIARY_FONT_SIZE,
  color: StyleConstants.ORANGE_COLOR,
};

export const columnHeader = (isMobile: boolean, marginBottom?: number): CSSProperties => ({
  width: '100%',
  wordBreak: 'break-word',
  textAlign: isMobile ? 'center' : undefined,
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  marginBottom,
});

export const button = (isMobile: boolean): CSSProperties => ({
  marginTop: isMobile ? 24 : undefined,
  marginBottom: isMobile ? 12 : undefined,
});

export const cornerButton = (isMobile = false): CSSProperties => ({
  marginLeft: isMobile ? 12 : 56,
  marginRight: isMobile ? 12 : 56,
  marginTop: isMobile ? 78 : 25,
});

export const emptyListMessage: CSSProperties = {
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const gridRow: CSSProperties = {
  marginTop: 12,
};

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const horizontalDivider: CSSProperties = {
  opacity: 0.5,
  height: 1,
  backgroundColor: 'rgba(36, 55, 75, 0.2)',
  marginBottom: 10,
  marginTop: 5,
};

export const saveMessage: CSSProperties = {
  color: StyleConstants.PINK_COLOR,
  fontSize: 12,
};

export const deleteButton: CSSProperties = {
  marginLeft: 12,
  marginTop: 28,
  marginBottom: 28,
  width: 180,
  cursor: 'pointer',
  wordBreak: 'break-word',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.PINK_COLOR,
};

export const deleteIcon: CSSProperties = {
  marginLeft: 8,
  height: 24,
  width: 24,
};

export const maxHeight: CSSProperties = {
  height: '100%',
};

export const officeListItem = (isLastItem = false): CSSProperties => ({
  cursor: 'pointer',
  padding: '10px 0',
  borderBottom: isLastItem ? undefined : '1px solid rgba(36, 55, 75, 0.1)',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
});

export const officeListChevronSx: SxProps = {
  height: 20,
  width: 20,
  color: StyleConstants.GREY_COLOR,
};

export const modalOfficeList: CSSProperties = {
  margin: '8px 0',
  paddingLeft: 20,
};
